"use strict";
// to expose things into global scope in a "safe" way for, e.g., calling in browser console...
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToBuiltNamespace = exports.addBuiltNamespace = exports.getRootNamespace = void 0;
const ROOT_NAMESPACE = 'Built';
if (!(ROOT_NAMESPACE in globalThis)) {
    globalThis[ROOT_NAMESPACE] = {};
}
else {
    const existingNsObj = globalThis[ROOT_NAMESPACE];
    if (!(typeof existingNsObj === 'object' && !!existingNsObj && !Array.isArray(existingNsObj))) {
        console.warn('Root namespace object of unexpected type. Overwriting. Was:', existingNsObj);
        globalThis[ROOT_NAMESPACE] = {};
    }
}
const ROOT_NS_OBJECT = globalThis[ROOT_NAMESPACE];
const isOkNamespace = /^([A-Z]{1}[A-Za-z]*\.?)+[A-Za-z]$/;
/**
 * Get the root namespace object.
 *
 * IMPORTANT: Adding anything other than namespaces to this is not recommended. Use addToBuiltNamespace() instead.
 *
 * @returns the root namespace object
 */
const getRootNamespace = () => ROOT_NS_OBJECT;
exports.getRootNamespace = getRootNamespace;
/**
 * Builds namespace object tree off of our root namespace (Built) for the given namespace.
 *
 * We only allow letters for namespaces and each must begin with a capital.
 *
 * Ex: if "FeatureArea.SubArea" is given, it will result in Built.FeatureArea.SubArea being available on the global namespace.
 *
 * @param namespace - single or dot-delimited namespace (using Pascal case).
 * */
const addBuiltNamespace = (namespace) => {
    if (!isOkNamespace.test(namespace)) {
        throw new Error('We only allow letters for namespaces and each must begin with a capital.');
    }
    const finalNamespaceObject = namespace
        .split('.')
        .reduce((namespaceObj, namespacePart) => { var _a; return (namespaceObj[namespacePart] = (_a = namespaceObj[namespacePart]) !== null && _a !== void 0 ? _a : {}); }, ROOT_NS_OBJECT);
    return finalNamespaceObject;
};
exports.addBuiltNamespace = addBuiltNamespace;
/**
 * Adds the given value as the value for the specified namespace member.
 *
 * Ensures that the given namespace is created/available.
 *
 * Ex:
 *   addToNamespace('FeatureArea.SubArea', 'myFunc', () => {});
 *   Then any code can access that via Built.FeatureArea.SubArea.myFunc();
 *
 * @param namespace - name of namespace (will be added under Built root)
 * @param memberName - member to add on that namespace (ex: name of a function)
 * @param value - value to add for the given member
 */
const addToBuiltNamespace = (namespace, memberName, value) => {
    (0, exports.addBuiltNamespace)(namespace)[memberName] = value;
};
exports.addToBuiltNamespace = addToBuiltNamespace;
